import io from "socket.io-client";

const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
//const ENDPOINT = isLocalhost ? "http://localhost:5000/messenger" : "https://sich.app/messenger";
const SERVER_URL = isLocalhost ? "http://localhost:5000" : "https://sich.onrender.com";
// Creating a single socket object
// const socket = io(ENDPOINT, { transports: ['websocket'] });
const socket = io(`${SERVER_URL}/messenger`, {
    transports: ['websocket'],
    reconnectionAttempts: 5,      // 5 times trying to reconnect
    reconnectionDelay: 5000,      // 5s pause between each reconnection attempt
    timeout: 20000,               // waiting 20s before connect error
    autoConnect: true  
});

export default socket;